import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
export function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  if (pathnames.length === 0) return null;
  return <nav className="flex mb-4" aria-label="Breadcrumb" data-id="element-2233">
      <ol className="flex items-center space-x-2" data-id="element-2234">
        <li data-id="element-2235">
          <div data-id="element-2236">
            <Link to="/" className="text-gray-400 hover:text-gray-500" data-id="element-2237">
              <Home className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-2238" />
              <span className="sr-only" data-id="element-2239">Home</span>
            </Link>
          </div>
        </li>
        {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const label = value.charAt(0).toUpperCase() + value.slice(1).replace(/-/g, ' ');
        return <li key={to} data-id="element-2240">
              <div className="flex items-center" data-id="element-2241">
                <ChevronRight className="h-4 w-4 flex-shrink-0 text-gray-300" aria-hidden="true" data-id="element-2242" />
                {isLast ? <span className="ml-2 text-sm font-medium text-gray-500" aria-current="page" data-id="element-2243">
                    {label}
                  </span> : <Link to={to} className="ml-2 text-sm font-medium text-gray-500 hover:text-gray-700" data-id="element-2244">
                    {label}
                  </Link>}
              </div>
            </li>;
      })}
      </ol>
    </nav>;
}